<template>
  <div class="mx-2">
    <div class="col-md-12 w-100 my-2 card p-2">
      <LoadingSpinner v-if="loadingOwarmList" />
      <div
        v-if="!loadingOwarmList && owarmStats.length > 0"
        class="mx-0 px-0 table-responsive"
      >
        <Table
          v-if="!loadingOwarmList && owarmStats.length > 0"
          class="mx-2 w-100"
          :headers="headers4"
          :cols="cols4"
          :data="owarmStats"
          :checkbox="false"
          :notselect="true"
          :model="model"
          @getOwarmStats="getOwarmStats"
        >
        </Table>
      </div>
    </div>
  </div>
</template>
<script>
import {
  statusBadgeMixin,
  statusPointMixin,
  statusFeedNotificationsMixin,
  formattersMixin
} from "@/_mixins/";
import Table from "@/components/Common/Table.vue";
import Pagination from "@/components/Common/Pagination.vue";
import LineChart from "@/components/Chart.vue";
import { adminService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  props: {
    groups: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      model: {},
      client_id: 0,
      paginationkey: 0,
      total: 0,
      loadingOwarmList: true,
      cantPerPage: 25,
      accountSelected: false,
      headers4: [
        {
          label: "Time",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11
        },
        {
          // email
          label: this.$t("lang.label.email"),
          size: "200px",
          class: "overflowhide"
        },
        {
          //client
          label: this.$t("lang.label.client"),
          size: "150px",
          class: "overflowhide"
        },
        {
          //userLinked
          label: this.$t("lang.label.userLinked"),
          size: "200px",
          class: "overflowhide"
        },
        {
          //firstname
          label: this.$t("lang.label.firstname"),
          size: "100px",
          class: "overflowhide"
        },
        {
          //lastname
          label: this.$t("lang.label.lastname"),
          size: "100px",
          class: "overflowhide"
        },
        {
          //start
          label: this.$t("lang.column.start"),
          size: "140px",
          class: "overflowhide"
        },
        // {
        //   //start
        //   label: 'Provider',
        //   size: "140px",
        //   class: "overflowhide"
        // },
        {
          //Synced
          label: "Synced",
          size: "80px",
          class: "overflowhide"
        },
        {
          //Status
          label: "Status",
          size: "80px",
          class: "overflowhide"
        },
        {
          label: "Reconnection",
          size: "130px",
          class: "overflowhide"
        },
        {
          label: "Last error",
          size: "240px",
          class: "overflowhide"
        },
        // {
        //   //Delivrability
        //   label: "Deliverability",
        //   size: "60px",
        //   class: "overflowhide"
        // },
        // {
        //   //DNS Score
        //   label: "DNS Score",
        //   size: "60px",
        //   class: "overflowhide"
        // },
        // {
        //   //ISP Score
        //   label: "ISP Score",
        //   size: "60px",
        //   class: "overflowhide"
        // },
        // {
        //   //Mailbox temperature
        //   label: "Mailbox temperature",
        //   size: "60px",
        //   class: "overflowhide"
        // },
        // {
        //   //Google Delivrability
        //   label: "Google",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "gmail-new-icon.png"
        // },
        // {
        //   //G Suite Delivrability
        //   label: "G Suite",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "icon_google.png"
        // },
        // {
        //   //Outlook
        //   label: "Outlook",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "icon_outlook.png"
        // },
        // {
        //   //OutlookBusiness
        //   label: "Outlook B.",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "icon_ms365.png"
        // },
        // {
        //   //Yahoo
        //   label: "Yahoo",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "icon_yahoo.png"
        // },
        // {
        //   // ICloud
        //   label: "ICloud",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "icon_icloud.png"
        // },
        // {
        //   // Zoho
        //   label: "Zoho",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "icon_zoho.svg"
        // },
        // {
        //   // Zoho Pro
        //   label: "Zoho Pro",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "icon_zoho.svg"
        // },
        // {
        //   //SMTP
        //   label: "SMTP",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "icon_email.png"
        // }
      ],
      cols4: [
        [
          {
            value: "task_open_hours",
            type: "time"
          }
        ],
        [
          //email
          {
            value_label: "email",
            value_emit: "id",
            class: "text-primary",
            type: "emit",
            emit: "getOwarmStats",
            icon: "icon-bar-chart text-primary pr-2"
          }
        ],
        [
          //client
          {
            value: "client_name"
          }
        ],
        [
          //userLinked
          {
            value: "user_email"
          }
        ],
        [
          //firstname
          {
            value: "name"
          }
        ],
        [
          //lastname
          {
            value: "lastname"
          }
        ],
        [
          //start
          {
            value: "start_on"
          }
        ],
        // [
        //   //provider
        //   {
        //     value: "warmup_provider"
        //   }
        // ],
        [
          //Synced
          {
            value: "warmup_active",
            show_text: "false",
            icons: [
              {
                icon_if_value: "1",
                icon_true: "icon-checkmark text-success"
              },
              {
                icon_if_value: "0",
                icon_true: "icon-cross text-danger"
              }
            ]
          }
        ],
        [
          //Status
          {
            value: "l_owarm_status",
            show_text: "false",
            icons: [
              {
                icon_if_value: "1",
                icon_true: "icon-checkmark text-success"
              },
              {
                icon_if_value: "0",
                icon_true: "icon-cross text-danger"
              }
            ]
          }
        ],
        [
          {
            value: "reconnection_last_status"
          }
        ],
        [
          {
            value: "reconnection_last_error"
          }
        ],
        // [
        //   //deliverability
        //   {
        //     value: "deliverability"
        //   }
        // ],
        // [
        //   // DNS score
        //   {
        //     value: "dns_score"
        //   }
        // ],
        // [
        //   // ISP score
        //   {
        //     value: "placement_score"
        //   }
        // ],
        // [
        //   // Mailbox temperature
        //   {
        //     value: "mailbox_temperature"
        //   }
        // ],
        // [
        //   // Gmail
        //   {
        //     value: "gmail_deliverability",
        //     show_text: "false",
        //     type: "percentage"
        //   }
        // ],
        // [
        //   //G Suite
        //   {
        //     value: "gsuite_deliverability",
        //     show_text: "false",
        //     type: "percentage"
        //   }
        // ],
        // [
        //   // Outlook
        //   {
        //     value: "outlook_deliverability",
        //     show_text: "false",
        //     type: "percentage"
        //   }
        // ],
        // [
        //   // OutlookBusiness
        //   {
        //     value: "ms365_deliverability",
        //     show_text: "false",
        //     type: "percentage"
        //   }
        // ],
        // [
        //   // Yahoo
        //   {
        //     value: "yahoo_deliverability",
        //     show_text: "false",
        //     type: "percentage"
        //   }
        // ],
        // [
        //   // ICloud
        //   {
        //     value: "icloud_deliverability",
        //     show_text: "false",
        //     type: "percentage"
        //   }
        // ],
        // [
        //   // Zoho
        //   {
        //     value: "zoho_deliverability",
        //     show_text: "false",
        //     type: "percentage"
        //   }
        // ],
        // [
        //   // Zoho Pro
        //   {
        //     value: "zohoPro_deliverability",
        //     show_text: "false",
        //     type: "percentage"
        //   }
        // ],
        // [
        //   // SMTP
        //   {
        //     value: "smtp_deliverability",
        //     show_text: "false",
        //     type: "percentage"
        //   }
        // ]
      ],
      openchart: false,
      owarmStats: [],
      owarmList: [],
      loadingOwarmList: true,
      loadOwarmStats: true
      // owarmOptions: [
      //   {
      //     // [0]
      //     id: "inbox",
      //     label: "inbox",
      //     role: ["1"],
      //     isDisabled: false,
      //     color: "51, 204, 204",
      //     yAxisID: "y1",
      //     type: "bar",
      //   },
      //   {
      //     // [1]
      //     id: "spam",
      //     label: "spam",
      //     role: ["1"],
      //     isDisabled: false,
      //     color: "255,0,0",
      //     yAxisID: "y1",
      //     type: "bar",
      //   },
      //   {
      //     // [2]
      //     id: "missing",
      //     label: "missing",
      //     role: ["1"],
      //     isDisabled: false,
      //     color: "155, 155, 155",
      //     yAxisID: "y1",
      //     type: "bar",
      //   },
      //   {
      //     // [3]
      //     id: "replies",
      //     label: "replies",
      //     role: ["1"],
      //     isDisabled: false,
      //     color: "0, 128, 0",
      //     yAxisID: "y1",
      //     type: "line",
      //   },
      //   {
      //     id: "accounts",
      //     label: "accounts",
      //     role: ["1"],
      //     isDisabled: false,
      //     color: "0, 32, 255",
      //     yAxisID: "y2",
      //     type: "line",
      //   },
      // ],

      // multiaxisOwarm: {
      //   labels: [],
      //   datasets: [],
      //   options: {
      //     responsive: true,
      //     title: {
      //       display: true,
      //       text: this.$t("lang.label.activity"),
      //     },
      //     scales: {
      //       yAxes: [
      //         {
      //           type: "linear",
      //           id: "y1",
      //           stacked: true,
      //           position: "right",
      //           display: true,
      //           gridLines: {
      //             drawOnChartArea: false,
      //           },
      //           ticks: {
      //             beginAtZero: true,
      //           },
      //         },
      //         {
      //           type: "linear",
      //           id: "y2",
      //           position: "left",
      //           display: true,
      //           ticks: {
      //             beginAtZero: true,
      //           },
      //         },
      //       ],
      //       xAxes: [
      //         {
      //           type: "time",
      //           time: {
      //             unit: "day",
      //           },
      //           stacked: true,
      //           offset: true,
      //           gridLines: {
      //             display: false,
      //           },
      //         },
      //       ],
      //     },
      //     tooltips: {
      //       callbacks: {
      //         label: function (tooltipItem, data) {
      //           var label = data.datasets[tooltipItem.datasetIndex].label || "";

      //           if (label) {
      //             label += ": ";
      //           }

      //           var currentQty = tooltipItem.yLabel; // data.datasets[tooltipItem.datasetIndex].data;
      //           //  console.log(data.datasets);
      //           label += currentQty;
      //           // console.log(tooltipItem )
      //           // [0] inbox, [1] spam, [2] missing, [3] replies
      //           if ([0, 1, 3].includes(tooltipItem.datasetIndex)) {
      //             let total =
      //               parseInt(data.datasets[0].data[tooltipItem.index]) +
      //               parseInt(data.datasets[1].data[tooltipItem.index]);
      //             label += " ("
      //             label +=
      //               parseFloat(
      //                 (currentQty * 100) /
      //                 total
      //               ).toFixed(2) + "%)";
      //           } else if (tooltipItem.datasetIndex == 2) {
      //             let total =
      //               parseInt(data.datasets[0].data[tooltipItem.index]) +
      //               parseInt(data.datasets[1].data[tooltipItem.index]) +
      //               parseInt(data.datasets[2].data[tooltipItem.index]);
      //             label += " ("
      //             label +=
      //               parseFloat(
      //                 (currentQty * 100) /
      //                 total
      //               ).toFixed(2) + "%)";
      //           }

      //           return label;
      //         },
      //       },
      //     },
      //   },
      // },
    };
  },
  components: {
    LineChart,
    LoadingSpinner,
    Table,
    Pagination
  },

  mixins: [
    statusBadgeMixin,
    statusPointMixin,
    statusFeedNotificationsMixin,
    formattersMixin
  ],

  computed: {
    user() {
      return this.$store.state.authentication.user;
    }
  },

  created() {
    if (this.model.cantPerPage == undefined) {
      this.model.currentPage = 1;
      this.model.cantPerPage = this.cantPerPage;
    }
    this.getOwarmStats();
  },

  methods: {
    getOwarmStats(id) {
      this.loadOwarmStats = true;
      adminService.getListOwarm(16, 0).then(result => {
        if (result.result == null) {
          this.owarmStats = [];
        } else {
          this.owarmStats = result.result;
        }

        this.loadOwarmStats = false;
        this.loadingOwarmList = false;
      });
    },
    convertToPercentage(value) {
      return `${value * 20}%`;
    }
  }
};
</script>

<style>
.stats-container {
  display: flex;
  gap: 22px; /* Ajusta el espacio entre los elementos */
}

.stat-item {
  white-space: nowrap; /* Evita que los elementos se rompan en líneas múltiples */
}
.table-scroll-container {
  overflow-x: auto;
  max-width: 100%;
}
</style>
